import { useEffect, useState } from 'react';

/**
 * `prefers-reduced-motion`, as a boolean that follows the OS setting live.
 *
 * The global stylesheet already neuters CSS animations for these users. This
 * is for the things CSS cannot reach: JavaScript-driven animation loops, where
 * the honest response is not to remove the information but to stop moving it
 * — sample less often, show the value plainly, skip the easing.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => {
    if (typeof window.matchMedia !== 'function') return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
